import * as React from "react";
import {Fragment, createRef} from "react";
import bootstrap from "../../../../node_modules/bootstrap/dist/js/bootstrap.bundle";
import KeySolver from "../../../KeySolver";
import ColorSelect from "./ColorSelect";
import PatternSelect from "./PatternSelect";
import Card from "../../Card/Card";

class Input extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			options: [],
			previousOptions: [],
			selectedValue: false,
			range: {
				position: 0,
				temporaryValue: 0
			},
			checked: false,
			setDefault: true,
		}
		this.input = React.createRef();
		this.applyConditions = this.applyConditions.bind(this);
		this.setOptions = this.setOptions.bind(this);
		this.setValue = this.setValue.bind(this);
		this.null = this.null.bind(this);
	}

	null() { }

	setValue() {
		if(this.input.current && this.input.current.dataset)  {
			const value = this.input.current.value;
			const trigger = this.input.current.dataset.trigger;

			console.log('trigger' + trigger);

			if(document.getElementById(trigger)) {
				const el = document.getElementById(trigger);
				console.log(el)
				if(el.type === 'checkbox' || el.type === 'radio') {
					if(!el.checked) {
						el.checked = true;
					} else {
						el.checked = false;
					}
				} else {
					el.value = value;
				}
				const event = new Event('change');
				document.getElementById(trigger).dispatchEvent(event);
			}

			this.setState({selectedValue: value}, () => {
				const type = this.input.current.attributes.type.value;
				if(type === 'range') {
					// w*100/g
					if(this.input.current.attributes.min && this.input.current.attributes.max) {
						const min = this.input.current.attributes.min.value;
						const value = this.state.selectedValue;
						const max = this.input.current.attributes.max.value;
						// console.log('0 % = ' + min);
						// console.log('100 % = ' + max);

						const newMax = parseInt(max) - parseInt(min);
						const onePercent = newMax / 100;
						const newValue = parseInt(value) - parseInt(min);
						const percentage = newValue / onePercent;


						this.setState({range: {position: percentage} })
					}

					const hasChildren = this.input.current.attributes['data-haschildren'];
					if(hasChildren) {
						// console.log('has children')
						// const id = this.input.current.id;
						const id = this.input.current.dataset.trigger;
						// console.log('id = ' + id);
						document.querySelectorAll(`[data-trigger=${id}]`).forEach(dataFor => {
							const dataForValue = dataFor.value;
							if(dataForValue === value) {
								this.setState({range: {temporaryValue: value} })

								const list = dataFor.getAttribute('list');
								if(document.getElementById(list)) {
									const listEl = document.getElementById(list);
									listEl.querySelectorAll('option').forEach(option => {
										const optionValue = option.value;
										if(optionValue === value) {
											const dataid = option.dataset.id;
											if(document.getElementById(dataid)) {
												// console.log('trigger: ' + dataid);
												// console.log('value: ' + value)
												document.getElementById(dataid).click();
											}
										}
									});
								}


							}
						});
					}

				}

				this.setOptions()
			});
		}
	}

	applyConditions(conditions) {

		for(let i in conditions) {
			const condition = conditions[i];
			if(condition.properties) {
				const operator = condition.properties.operator;
				const key = condition.properties.key;
				const value = condition.properties.value;
				const el = document.querySelector(`[data-id="${key}"]`);

				if(operator === '=') {
					return parseInt(el.value) === parseInt(value);
				}
				if(operator === '≠') {
					return parseInt(el.value) !== parseInt(value);
				}
				if(operator === '>') {
					return parseInt(el.value) > parseInt(value);
				}
				if(operator === '<') {
					return parseInt(el.value) < parseInt(value);
				}
				if(operator === '>=') {
					return parseInt(el.value) >= parseInt(value);
				}
				if(operator === '<=') {
					return parseInt(el.value) <= parseInt(value);
				}
			}
		}

		return false;
	}

	setOptions() {
		const options = this.props.input.children ? this.props.input.children : false;
		let items = [];
		if(options) {
			for (let i in options) {
				if(options[i].conditions) {
					if(this.applyConditions(options[i].conditions)) {
						items[i] = options[i];
					}
				} else {
					items[i] = options[i];
				}
			}
		}
		this.setState({options: items});
	}

	componentDidMount() {
		const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
		const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));
		this.setOptions();
		// document.querySelectorAll('.main input[type="range"]').forEach(input => {
		// 	console.log(input.type)
		// 	input.addEventListener('change', (e) => { this.setOptions() });
		// });

		const {input} = this.props;
		if(input.properties.inputType === 'range') {
			document.querySelectorAll('.main input[type="range"]').forEach(input => {
				// console.log(input.type)
				input.addEventListener('change', (e) => { this.setOptions() });
				// if(input.type === 'range' && input.dataset.haschildren) {
				// 	input.value = input.dataset.defaultvalue;
				// }
			});
		}
	}

	componentDidUpdate(prevProps, prevState) {

		if (this.state.options.length !== prevState.previousOptions.length ||
			this.state.options.some((option, index) => option !== prevState.previousOptions[index])) {

			if(this.input) {
				// console.log(this.input.current)
				if(this.input && this.input.current) {
					this.input.current.dispatchEvent(new Event('change', { bubbles: true }));
				}
			}

		}
	}


	render() {

		const {input, shortcut} = this.props;
		const {options, selectedValue, setDefault} = this.state;

		const fieldId = input.properties.id ? input.properties.id : `input_${input.identifier}`;
		const inputType = input.properties ? input.properties.inputType : false;
		const items = input.properties ? input.properties.items : false;
		const categories = input.properties ? input.properties.categories : [];
		// const showAsRadio = input.properties ? input.properties.showAsRadio : false;

		// console.log(input)


		// Range slider specific
		const rangeHasChildren = inputType === 'range' ? (input.children ? input.children.length > 0 : false) : false;
		let minValue = input.properties.minValue ? input.properties.minValue : false;
		let maxValue = input.properties.maxValue ? input.properties.maxValue : false;
		let steps = input.properties.steps ? input.properties.steps : false;
		let halfValue = minValue && maxValue ? ((parseInt(maxValue) + parseInt(minValue)) / 2) : false;

		let calculatedDefaultValue = '0';
		if(rangeHasChildren) {
			if(options.length > 0) {
				if(options[0] && options[1] && options[0].properties && options[1].properties) {
					minValue = parseInt(options[0].properties.value);
					maxValue = parseInt(options[options.length - 1].properties.value);
					steps = parseInt(options[1].properties.value) - parseInt(options[0].properties.value);

					// console.log(minValue)
					// console.log(maxValue)
					// console.log(steps);

					calculatedDefaultValue = parseInt(input.properties.defaultValue) < maxValue ? parseInt(input.properties.defaultValue) : parseInt(parseInt(maxValue) / 2);

					console.log(calculatedDefaultValue)


				}
			}
		}

		// Select specific
		const selectAsRadio = inputType === 'select' ? (input.properties.showAsRadio ? input.properties.showAsRadio : false) : false;

		return (
			<Fragment>
				<div className={`${inputType === 'checkbox' ? `col-md-6` : `col-12`} mb-3`} >
					<div className="row align-items-center">
						{inputType !== 'ral' && inputType !== 'pattern' && inputType !== 'checkbox' &&
							<div className="col-10">
								<label htmlFor={`${fieldId}`} >{input.properties.title}</label>
							</div>
						}
						{input.properties.description && inputType !== 'checkbox' &&
							<div className="col-2 text-end text-muted info-text ms-auto">
								<i className="far fa-question-circle" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-custom-class="custom-tooltip" data-bs-title={input.properties.description} />
							</div>
						}
					</div>
					{inputType === 'range' &&
						<Fragment>
							<div className="position-relative">
								{!rangeHasChildren &&
									// <input ref={this.input} id={`${fieldId}`} type="range" className="form-range form-range-lg" min={minValue.toString()} max={maxValue.toString()} step={steps.toString()} data-id={input.identifier} data-trigger={input.properties.id} defaultValue={halfValue.toString()} onChange={() => this.setValue()} />
									<input ref={this.input} id={`${fieldId}`} type="range" className="form-range form-range-lg" min={minValue.toString()} max={maxValue.toString()} step={steps.toString()} data-id={input.identifier} data-trigger={input.properties.id} defaultValue={input && input.properties && input.properties.defaultValue} onChange={() => this.setValue()} />
								}
								{rangeHasChildren &&
									<Fragment>
										{/*<input ref={this.input} id={`${fieldId}`} type="range" className="form-range form-range-lg" data-id={input.identifier} data-trigger={input.properties.id} data-haschildren={true} min={minValue.toString()} max={maxValue.toString()} step={steps.toString()} list={`${fieldId}_values`} defaultValue={minValue} onChange={() => this.setValue()} />*/}
										{/*<input ref={this.input} type="range" className="form-range form-range-lg" data-id={input.identifier} data-trigger={input.properties.id} data-haschildren={true} min={minValue.toString()} max={maxValue.toString()} step={steps.toString()} list={`${fieldId}_values`} defaultValue={input.properties.defaultValue ? input.properties.defaultValue : minValue} onChange={() => this.setValue()} />*/}
										{options && options.length > 0 &&
											<Fragment>

												<input ref={this.input} id={`${fieldId}`} type="range" className="form-range form-range-lg" data-id={input.identifier} data-trigger={input.properties.id} data-haschildren={true} list={`${fieldId}_values`} min={options && options.length > 0 && options[0].properties.value.toString().replaceAll(' mm', '')} max={options && options.length > 0 && options[(options.length - 1)].properties.value.toString().replaceAll(' mm', '')} step={steps.toString()} defaultValue={input && input.properties && input.properties.defaultValue} onChange={() => {
													this.setState({setDefault: false});
													this.setValue()
												}}/>

												<datalist id={`${fieldId}_values`} className="text-muted">
													{options.map(rangeItem =>
														<Fragment key={KeySolver()}>
															<option value={parseInt(rangeItem.properties.value)} data-id={rangeItem.properties.id} label={`${parseInt(rangeItem.properties.value)} mm`}></option>
														</Fragment>
													)}
												</datalist>

											</Fragment>
										}

										{/*<input type="range" min={minValue.toString()} max={maxValue.toString()} step={steps.toString()} value={calculatedDefaultValue.toString()} onChange={() => null()} />*/}
										{/*<input type="range" min="1500" max="3000" step="500" value="2500" />*/}

										{/*<div className="row g-0">*/}
										{/*	{options.map((rangeItem, i) =>*/}
										{/*		<Fragment key={KeySolver()} >*/}
										{/*			<div className={`col ${i === 0 ? `text-left` : (i === (options.length - 1) ? `text-end` : `text-center`)}`} >*/}
										{/*				<small className="text-muted">*/}
										{/*					{`${parseInt(rangeItem.properties.value)} mm`}*/}
										{/*				</small>*/}
										{/*			</div>*/}
										{/*		</Fragment>*/}
										{/*	)}*/}
										{/*</div>*/}

										{/*<div className="d-block d-none">*/}
										{/*	{options.map(rangeItem =>*/}
										{/*		<Fragment key={KeySolver()} >*/}
										{/*			<input type="checkbox" id={rangeItem.properties.id} data-for={`${fieldId}`} defaultValue={parseInt(rangeItem.properties.value)} defaultChecked={parseInt(this.state.range.temporaryValue) === parseInt(rangeItem.properties.value)} />*/}
										{/*		</Fragment>*/}
										{/*	)}*/}
										{/*</div>*/}

									</Fragment>
								}
								{!rangeHasChildren &&
									<output
										className="position-absolute"
										style={{left: `${selectedValue ? this.state.range.position : '50'}%`, top: '0', marginTop: '1.9rem', width: '6rem', marginLeft: '-3rem', textAlign: 'center'}}
									>
										<small className="text-muted">{selectedValue ? selectedValue : (input.properties.defaultValue ? input.properties.defaultValue : '')} mm</small>
									</output>
								}
							</div>
							{minValue && maxValue && !rangeHasChildren &&
								<div className="row align-items-center">
									<div className="col-6">
										<small className="text-muted">{minValue} mm</small>
									</div>
									<div className="col-6 text-end">
										<small className="text-muted">{maxValue} mm</small>
									</div>
								</div>
							}
						</Fragment>
					}
					{inputType === 'select' &&
						<Fragment>
							{!selectAsRadio &&
								<Fragment>
									{input.children.length > 0 &&
										<Fragment>
											<select ref={this.input} id={`${fieldId}`} className="form-select form-select-lg" data-id={input.identifier} defaultValue={selectedValue} >
												<option disabled={true} selected={true} >Bitte auswählen</option>
												{options.map(option =>
													<Fragment key={KeySolver()} >
														<option value={option.properties.value} >
															{option.properties.title}
														</option>
													</Fragment>
												)}
											</select>
										</Fragment>
									}
								</Fragment>
							}
							{selectAsRadio &&
								<Fragment>
									{input.children.length > 0 &&
										<Fragment>
											<div className="row align-items-center" >
												<input type="hidden" id={`${fieldId}`} data-id={input.identifier} value={this.state.checked} onChange={() => this.null()} />
												{input.children.map((radioItem, i) =>
													<Fragment key={KeySolver()} >
														<div className="col-md-6 my-3">
															<Card className="radio-cart" >
																<div className="form-check">
																	{/*<input className="form-check-input" type="radio" name={`${fieldId}`} value="" data-id={radioItem.properties.id} id={`check_${fieldId}_${i}`} />*/}
																	<input className="form-check-input" type="radio" name={`${fieldId}`} data-isradio={true} data-id={radioItem.properties.id} data-trigger={`${radioItem.properties.id}`} id={`${fieldId}_${i}`} defaultValue={radioItem.properties.title} checked={!this.state.checked ? (radioItem.properties.checked ? true : false) : (this.state.checked === radioItem.properties.title ? true : false)} onChange={() => {this.setState({checked: radioItem.properties.title}); document.getElementById(radioItem.properties.id).click(); } } />
																	<label className="form-check-label" htmlFor={`${fieldId}_${i}`} >
																		<span>{radioItem.properties.title}</span>
																	</label>
																</div>
															</Card>
														</div>
													</Fragment>
												)}
											</div>
										</Fragment>
									}
								</Fragment>
							}
						</Fragment>
					}
					{inputType === 'ral' &&
						<ColorSelect endpoint="/api/color/ral" items={items} categories={categories} reference={this.input} id={`${fieldId}`} dataId={input.identifier} defaultItems={input.properties.defaultRal} input={input} />
					}
					{inputType === 'pattern' &&
						<PatternSelect endpoint={`/api/pattern${shortcut ? `/${shortcut}` : ''}`} inputType={inputType} items={items} categories={categories} reference={this.input} id={`${fieldId}`} dataId={input.identifier} input={input} volant={false} />
					}
					{inputType === 'patternVolant' &&
						<PatternSelect endpoint={`/api/pattern${shortcut ? `/${shortcut}` : ''}`} inputType={inputType} items={items} categories={categories} reference={this.input} id={`${fieldId}`} dataId={input.identifier} input={input} volant={true} />
					}
					{inputType === 'checkbox' &&
						<Fragment>
							<Card className="radio-cart h-100" >
								<div className="form-check h-100">
									<input ref={this.input} data-trigger={`${fieldId}`} className="form-check-input" type="checkbox" name={`${fieldId}`} data-id={input.identifier} value="1" id={`check_${fieldId}`} onChange={() => this.setValue()} />
									<label className="form-check-label w-100"  htmlFor={`check_${fieldId}`} >
										<span>{input.properties.title}</span>
										{input.properties.description &&
											<div className="row align-items-center mt-2 h-100">
												<div className="col-4">
													<div className="description-image">
														{input.properties.descriptionImage &&
															<img src={input.properties.descriptionImage} alt={input.properties.title} className="img-fluid img-cover" />
														}
													</div>
												</div>
												<div className="col-8">
													<span className="d-block">
														<em>{input.properties.description}</em>
													</span>
												</div>
											</div>
										}
									</label>
								</div>
							</Card>
						</Fragment>
					}
				</div>
				{/*<input ref={this.input} id={`${fieldId}`} type="text" className="form-control form-control-lg" data-id={input.identifier} />*/}
			</Fragment>
		);
	}
}

export default Input;
